module.exports = __webpack_public_path__ + "img/tabs.21cd56dc.png";